module.exports = __webpack_public_path__ + "static/media/icon-home.4aff6d3c.png";